import { render, staticRenderFns } from "./remCom.vue?vue&type=template&id=53e7a1a7&scoped=true"
import script from "./remCom.vue?vue&type=script&lang=js"
export * from "./remCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rem.css?vue&type=style&index=0&id=53e7a1a7&prod&scoped=true&lang=css&external"
import style1 from "./remCom.vue?vue&type=style&index=1&id=53e7a1a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7a1a7",
  null
  
)

export default component.exports